// extracted by mini-css-extract-plugin
export var deleteIcon = "_ou-5";
export var deleteOption = "_ou-3";
export var divider = "_ou-2";
export var downloadIcon = "_ou-4";
export var drawer = "_ou-0";
export var drawerFooter = "_ou-6";
export var drawerOpen = "_ou-1";
export var highlighted = "_ou-7";
export var lighterHighlight = "_ou-8";